import React, { useEffect, useState } from 'react';
import { Clock, RefreshCw } from 'lucide-react';
interface DataFreshnessProps {
  /** Last sync / activity time. Pass null when no activity has been recorded yet. */
  updatedAt: number | Date | null;
  onRefresh?: () => void;
  className?: string;
}
export function DataFreshness({
  updatedAt,
  onRefresh,
  className = ''
}: DataFreshnessProps) {
  const [now, setNow] = useState(Date.now());
  const [isRefreshing, setIsRefreshing] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  const handleRefresh = () => {
    if (isRefreshing || !onRefresh) return;
    setIsRefreshing(true);
    onRefresh();
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };
  let label: string;
  if (updatedAt === null || updatedAt === undefined) {
    label = 'Nog geen activiteit';
  } else {
    const time = typeof updatedAt === 'number' ? updatedAt : updatedAt.getTime();
    const diffMs = now - time;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    if (diffSec < 30) {
      label = 'Net bijgewerkt';
    } else if (diffMin < 60) {
      label = `${diffMin} min geleden`;
    } else if (diffHour < 24) {
      label = `${diffHour} uur geleden`;
    } else {
      label = new Date(time).toLocaleString('nl-NL', {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
  return <div className={`inline-flex items-center gap-1.5 text-xs text-slate-500 font-medium ${className}`} data-id="element-7658">
      <Clock className="w-3 h-3" data-id="element-7659" />
      <span data-id="element-7660">{label}</span>
      {onRefresh && <button onClick={handleRefresh} disabled={isRefreshing} className="p-1 hover:bg-slate-100 rounded-md transition-colors ml-1" aria-label="Vernieuwen" data-id="element-7661">
          <RefreshCw className={`w-3 h-3 ${isRefreshing ? 'animate-spin text-indigo-500' : 'text-slate-400'}`} data-id="element-7662" />
        </button>}
    </div>;
}